// extracted by mini-css-extract-plugin
module.exports = {"notificationDot":"NotificationDot_notificationDot__bMyn9","small":"NotificationDot_small__aUkIV","medium":"NotificationDot_medium__OqrUM"};